// View mode — the "two-speed" app (Proposal C). "simple" is the calm, jargon-light
// surface for a non-quant operator (Today / Portfolio / Trade); "pro" is the full power-user
// app (Dashboard / Portfolio / Trading / Calendar / Designer + Research). Same engine,
// same data, same components — only nav + a few default densities change.
//
// Default is ROLE-BASED for a user who hasn't chosen: the owner/superuser → "pro" (today's
// app, unchanged); everyone else → "simple". Once a user toggles, their choice is persisted
// in localStorage and wins over the role default. Toggled from the user menu.
import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useMe } from "./auth.jsx";

const ModeCtx = createContext({ mode: "pro", pro: true, simple: false, set: () => {}, toggle: () => {} });

export function ModeProvider({ children }) {
  const { me } = useMe();
  const roleDefault = me?.is_superuser ? "pro" : "simple";
  // null = the user hasn't chosen; fall back to the role default (no localStorage write
  // until they actually pick, so the default can still follow the role once `me` loads).
  const [chosen, setChosen] = useState(() => {
    try { return localStorage.getItem("cc-mode"); } catch { return null; }
  });
  useEffect(() => { if (chosen != null) { try { localStorage.setItem("cc-mode", chosen); } catch {} } }, [chosen]);
  const mode = chosen || roleDefault;
  const set = useCallback((m) => setChosen(m === "simple" ? "simple" : "pro"), []);
  const toggle = useCallback(() => setChosen(mode === "pro" ? "simple" : "pro"), [mode]);
  return (
    <ModeCtx.Provider value={{ mode, pro: mode === "pro", simple: mode === "simple", set, toggle }}>
      {children}
    </ModeCtx.Provider>
  );
}

export const useMode = () => useContext(ModeCtx);
